import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import {  DeliverService, DeliverServicesClient, ServiceProvider, ServiceProvidersClient } from "src/app/web-api-client";
import { SuccessModalComponent } from "../../../../modals/success-modal/success-modal.component";
import { DeliverServiceCreationComponent } from "./deliverService-creation/deliverService-creation.component";
import { DeliverServiceEditComponent } from "./deliverService-edit/deliverService-edit.component";
import { NgbActiveModal, NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { Subject } from "rxjs";

@Component({
  selector: 'app-serviceProvider-edit',
  templateUrl: './serviceProvider-edit.component.html',
  styleUrls: ['./serviceProvider-edit.component.scss'],
  changeDetection:ChangeDetectionStrategy.OnPush
})
export class ServiceProviderEditComponent implements OnInit {
  public onClose = new Subject<boolean>();
  public isLoaded = false;
  public editObject: ServiceProvider;
  public services: DeliverService[];
  public selectedService: DeliverService;
  Form: FormGroup;
  // Assuming you have a property for all the services
  public searchQuery: string = '';
  public filteredServices: DeliverService[] = [];
  serviceTermTypes = [
    { value: 0, label: 'Неизвестен' },
    { value: 1, label: 'Експресна' },
    { value: 2, label: 'Бърза' },
    { value: 3, label: 'Обикновена' }
  ];
  constructor(private fb: FormBuilder,public activeModal: NgbActiveModal,public changeDetectionRef:ChangeDetectorRef, public client: ServiceProvidersClient, public deliverServiceClient: DeliverServicesClient, public modalService: NgbModal) { }

  ngOnInit(): void {

    this.LoadData();

  }

  private LoadData() {
    this.isLoaded = false;
        this.deliverServiceClient.getList(this.editObject.idServiceProvider).subscribe(d => {

          this.services = d;
          this.filteredServices = d;
            this.initializeForm();
          this.isLoaded = true;
          this.changeDetectionRef.detectChanges();
        });
    }



  filterServices() {
    if (this.searchQuery) {
      this.filteredServices = this.services.filter(service =>
        service.service.yri.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.title.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.service.serviceName.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.deliverTaxe.toString().toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.bankDetails?.iban?.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.bankDetails?.title?.toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        service.isActive.toString().toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        (service.sample || '').toLowerCase().includes(this.searchQuery.toLowerCase()) ||
        this.getServiceTermTypeLabel(service.serviceTermTypeId).toLowerCase().includes(this.searchQuery.toLowerCase())
      );
    } else {
      this.filteredServices = this.services;
    }
  }


  initializeForm() {
    this.Form = this.fb.group({
      serviceProviderName: [this.editObject.serviceProviderName, Validators.required],
      serviceProviderEIK: [this.editObject.serviceProviderEIK, Validators.required],
      isActive: [this.editObject.isActive, Validators.required],
    });
  }

  onSubmit() {
    if (this.Form.valid) {


      this.editObject.serviceProviderName = this.Form.value.serviceProviderName;
      this.editObject.serviceProviderEIK = this.Form.value.serviceProviderEIK;
      this.editObject.isActive = this.Form.value.isActive;



      this.client.update(this.editObject).subscribe((user) => {
        this.onClose.next(true);
        this.activeModal.close();
      });
    }
  }

  public onUserSelected(service: DeliverService) {
    if (this.isSelected(service)) {
      this.selectedService = null;
    }
    else {

      this.selectedService = service;
    }

    this.changeDetectionRef.detectChanges();
  }

  public isSelected(service: DeliverService): boolean {
    let result = this.selectedService != null && this.selectedService == service;

    return result;
  }

  closeModal() {
    this.onClose.next(true);
    this.activeModal.close();
  }

  public onCreation(): void {

    const modalRef = this.modalService.open(DeliverServiceCreationComponent, { size: 'xl', centered: true,backdrop:'static' });
    modalRef.componentInstance.serviceProviderId = this.editObject.idServiceProvider;
    modalRef.componentInstance.onClose.subscribe(r => {

      this.LoadData();

    });
  }


  public onDelete(): void {

    this.deliverServiceClient.remove(this.selectedService.idDeliversService).subscribe(r => {
      this.modalService.open(SuccessModalComponent, {});
    });
  }

  public onEdit(): void {

    let modalRef = this.modalService.open(DeliverServiceEditComponent, {
      size: 'xl',
      centered: true,
      backdrop:'static',
      windowClass: 'modal-xxl'
    });
    modalRef.componentInstance.editObject = this.selectedService;

    modalRef.componentInstance.onClose.subscribe(r => {

      this.LoadData();
    });
  }

  public getBankDetails(service: DeliverService): string {

    if(!service.bankDetails)
    {
      return "Няма въведени банкови данни";
    }

    // With larger modal, we can show more text
    // Truncate title if too long (max 18 chars)
    let title = service.bankDetails.title.trim();
    if (title.length > 18) {
      title = title.substring(0, 18) + '...';
    }

    // Truncate IBAN - show first 2 (country code) + next 4 + ... + last 4
    // Example: BG94RZBB9155106362319 becomes BG94RZ...2319
    let iban = service.bankDetails.iban;
    if (iban.length > 16) {
      iban = iban.substring(0, 8) + '...' + iban.substring(iban.length - 4);
    }

    let result = title + " (" + iban + ")";
    return result;
  }

  public getFullBankDetails(service: DeliverService): string {

    if(!service.bankDetails)
    {
      return "Няма въведени банкови данни";
    }

    // Return full text for tooltip
    let result = service.bankDetails.title + " (" + service.bankDetails.iban + ")";
    return result;
  }

  public getServiceTermTypeLabel(value: number): string {
    const termType = this.serviceTermTypes.find(t => t.value === (value || 0));
    return termType ? termType.label : '-';
  }

}
